import ApiService from '@/services/api.service';

const PatientPortalNotePackageHdrsService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalNotePackageHdrs/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalNotePackageHdrs/${id}`);
    },

    add(data) {
        return ApiService.post('/PatientPortalNotePackageHdrs', data);
    },

    getNotesIds(packageIds) {
        return ApiService.getWithArray('/PatientPortalNotePackageHdrs/NotesIds', {
            PackageIds: packageIds
        });
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalNotePackageHdrs/${id}`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalNotePackageHdrs/${id}`);
    }
};

export default PatientPortalNotePackageHdrsService;
